var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCurvaTop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 263,
    height: 54,
    viewBox: "0 0 263 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M262.436 0.000115355C149.038 0.000115355 190.324 54 130.678 54C71.0325 54 104.758 0.000115355 0 0.000115355C47.5193 0.00118239 71.0325 0 130.678 0C190.324 0 262.436 0.000115355 262.436 0.000115355Z",
    fill: "#030014"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.329 24.2907C120.037 23.5828 121.184 23.5828 121.892 24.2907L131.486 33.8846L141.08 24.2907C141.788 23.5828 142.935 23.5828 143.643 24.2907C144.351 24.9985 144.351 26.1462 143.643 26.8541L131.486 39.0114L119.329 26.8541C118.621 26.1462 118.621 24.9985 119.329 24.2907Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurvaTop);
export default __webpack_public_path__ + "static/media/curva_top.6b13155fded8ddc66b9b60170986b920.svg";
export { ForwardRef as ReactComponent };